module.exports = __webpack_public_path__ + "img/facebook-invite.e917de26.svg";